export const RESET = 'APPLICATION_UPDATE_RESET'
export const SET_ERROR = 'APPLICATION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'APPLICATION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'APPLICATION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'APPLICATION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'APPLICATION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'APPLICATION_UPDATE_UPDATE_RETRIEVED'
